// extracted by mini-css-extract-plugin
export var active = "_ae-d";
export var blink = "_ae-e";
export var container = "_ae-5";
export var controls = "_ae-0";
export var controlsRight = "_ae-1";
export var fakeCursor = "_ae-c";
export var hidden = "_ae-b";
export var quillContainerSmall = "_ae-7";
export var quillEditor = "_ae-6";
export var quillEditorSmall = "_ae-8";
export var quillFormatButtons = "_ae-a";
export var quillToolbar = "_ae-9";
export var removePadding = "_ae-2";
export var state = "_ae-3";
export var stateTitle = "_ae-4";